export default __webpack_public_path__ + "static/media/instagram.afd1c0b8.png";